import { render, staticRenderFns } from "./Display.vue?vue&type=template&id=0de797dd&scoped=true&"
import script from "./Display.vue?vue&type=script&lang=ts&"
export * from "./Display.vue?vue&type=script&lang=ts&"
import style0 from "./Display.vue?vue&type=style&index=0&id=0de797dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0de797dd",
  null
  
)

export default component.exports